<!-- Destination Buttons -->
<ziro-call-flow-destinations-form
  [attr.data-automation]="callFlow().isHoliday ? 'call-flow-holiday-destinations-form' : 'call-flow-destinations-form'"
  [tenantId]="tenantId()"
  [callFlow]="callFlow()"
  (greetingUpdate)="greetingUpdate.emit($event)"
></ziro-call-flow-destinations-form>
